export const formatEditorString = (note: string) => note?.replace(/<[^>]*>?/g, '');

export const cleanEditorText = (text: string): string => {
  const formattedText = formatEditorString(text);

  return formattedText === '' ? formattedText : text;
};
